<template>
	<div class="card mb-2" :class="{'card-success': review.review_status == 'Согласован', 'card-danger': review.review_status == 'Отклонен'}">
		<div class="card-body p-0 font-size-14 d-flex justify-content-between">
			<div class="d-flex flex-column gap-1 p-3">
				<div>
					<card-field-component
					type="select"
					:no-title="true"
					:no-margin="true"
					v-model="review.review_status"
					:display-value="review.review_status"
					mode="show"
					:options="[
						{ text: 'В ожидании', icon: 'clock text-muted', value: 'В ожидании' },
						{ text: 'Согласован', icon: 'check text-success', value: 'Согласован' },
						{ text: 'Отклонен', icon: 'ban text-danger', value: 'Отклонен' }
					]"
					/>
				</div>
				<div class="">
					<span class="text-muted">Номер исходящего: </span>
					<span class="text-truncate-two-lines">{{ review.review_title ? review.review_title : '–' }}</span>
				</div>
				<div class="">
					<span class="text-muted">Дата исходящего: </span>
					<span class="text-nowrap">{{ review.review_outgoing_date ? moment(review.review_outgoing_date).format('D MMMM Y') : '–' }}</span>
				</div>
				<div class="d-flex gap-2" v-if="review.review_notes">
					<div class="text-muted">Заметка:</div>
					<card-field-component
					:no-margin="true"
					:no-title="true"
					type="text"
					title="Заметки"
					v-model="review.review_notes"
					:display-value="review.review_notes"
					mode="show"
					/>
				</div>
				<div v-if="!epgu" class="mt-1">
					<button
					type="button" 
					@click="openModal" 
					class="m-0 p-0 btn btn-link"
					>
						<span v-b-popover.hover.focus="'Просмотр и редактирование решения по заявке'">
							<span class="far fa-edit fa-fw text-primary"></span>
							<span class="font-size-14">Просмотр</span>
						</span>
					</button>
				</div>
			</div>
			<div v-if="review.media && review.media.length">
				<media-collection
				v-if="review.media.filter(o => o.collection_name === 'default').length == 1"
				title=""
				:files="review.media"
				:collection-name="'default'"
				:mode="'show'"
				/>
				<div class="p-2" v-else-if="review.media.filter(o => o.collection_name === 'default').length > 1">
					<b-dropdown dropright no-caret text="Файлы" variant="link" size="sm" class="btn-text-inline-dropdown text-nowrap">
						<template v-slot:button-content>
							<div class="position-relative">
								<media-link
								mode="show"
								class="m-1"
								:disabled="true"
								:item="review.media.filter(o => o.collection_name === 'default')[0]"
								/>
								<div class="position-absolute badge badge-primary" style="left: 0; width: 100%; top: 50%; font-size: 12px; margin-top: -1em;">
									<span class="far fa-paperclip fa-fw"></span> 
									<decl-of-num class="d-none d-md-inline-block" :number="review.media.length" :titles="['файл', 'файла', 'файлов']" :print="true"/>
									<span class="d-inline-block d-md-none">{{ review.media.length }}</span>
								</div>
							</div>
						</template>
						<div class="d-flex">
							<media-collection
							v-if="review.media.filter(o => o.collection_name === 'default').length"
							class="px-2 py-1"
							title=""
							:files="review.media"
							:collection-name="'default'"
							:mode="'show'"
							/>
						</div>
					</b-dropdown>
				</div>
			</div>
		</div>

		<b-modal
		:lazy="true"
		:ref="'modal'"
		size="md"
		modal-class="shadow"
		header-class="py-2"
		title-tag="h6"
		hide-footer
		footer-class="d-flex bg-light p-3"
		body-class="p-0"
		show
		no-fade
		@hidden="onModalHidden"
		>

			<div slot="modal-title">
				Решение {{ type == 'application' ? 'по заявке' : (type == 'project' ? 'по проекту' : '') }}
			</div>

			<card-component
			:model="['review', 'reviews/review']"
			:id="review.id"
			:fields-list="[
				'review_outgoing_date',
				'review_title',
				'file',
				'sig',
			]"
			v-on:updated="refetch"
			:no-redirect="true"
			>
			<template v-slot:card="slotProps">
				<div class="card-body">
					<div class="w-m-1000">
						<div class="px-3" v-if="slotProps.editableItem">
							<div class="row">
								<div class="col-6">
									<card-field-component
									fieldname="review_status"
									:errors="errors"
									type="select"
									title="Статус решения"
									v-model="slotProps.editableItem.review_status"
									:display-value="slotProps.item.review_status"
									:disabled="slotProps.fetching"
									:mode="slotProps.mode"
									:options="[
										{ text: 'Согласован', icon: 'check text-success', value: 'Согласован' },
										{ text: 'Отклонен', icon: 'ban text-danger', value: 'Отклонен' },
										{ text: 'Отказано в предоставлении услуги', icon: 'ban text-danger', value: 'Отказано в предоставлении услуги' },
										{ text: 'Отменена заявителем', icon: 'ban text-danger', value: 'Отменена заявителем' }
									]"
									v-on:update:value="slotProps.editableItem.review_status = $event"
									:is-required="true"
									/>
								</div>
							</div>
							<div class="row">
								<div class="col-6">
									<card-field-component
									type="date"
									title="Дата исходящего"
									fieldname="review_outgoing_date"
									:errors="errors"
									v-model="slotProps.editableItem.review_outgoing_date"
									:display-value="slotProps.item.review_outgoing_date"
									:disabled="slotProps.fetching"
									:mode="slotProps.mode"
									v-on:update:value="slotProps.editableItem.review_outgoing_date = $event"
									:is-required="true"
									/>
								</div>
								<div class="col-6">
									<card-field-component
									type="text"
									title="Номер согласования"
									fieldname="review_title"
									:errors="errors"
									v-model="slotProps.editableItem.review_title"
									:display-value="slotProps.item.review_title"
									:disabled="slotProps.fetching"
									:mode="slotProps.mode"
									v-on:update:value="slotProps.editableItem.review_title = $event"
									:is-required="true"
									/>
								</div>
							
							</div>
							<div class="row">
								<div class="col-6">
									<media-collection
									type="filebase64"
									title="Файл решения"
									class="my-3"
									:files="slotProps.item.media"
									:uploads="slotProps.uploads"
									:removed="slotProps.removed"
									:collection-name="'default'"
									:disabled="slotProps.fetching"
									:mode="slotProps.mode"
									/>
								</div>
								<div class="col-6">
									<media-collection
									type="filebase64"
									title="Файл подписи"
									class="my-3"
									:files="slotProps.item.media"
									:uploads="slotProps.uploads"
									:removed="slotProps.removed"
									:collection-name="'sig'"
									:disabled="slotProps.fetching"
									:mode="slotProps.mode"
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</template>
			</card-component>
		</b-modal>
	</div>
</template>

<script>
	import moment from 'moment'
	export default {
		props: [
			'review', 'epgu', 'type'
		],
		data () {
			return {
				errors: [],
				modal: null,
				moment: moment
			}
		},
		computed: {
		},
		mounted () {
			this.modal = this.$refs.modal
		},
		methods: {
			openModal () {
				this.modal.show()
			},
			onModalHidden () {
				this.errors =  []
			},
			refetch () {
				this.$refs.modal.hide()
				this.$emit('refetch')
			}
		}
	}
</script>